export default __webpack_public_path__ + "static/media/Concox-GT710.271817ae.jpg";